import { IRadioBlockItem } from "common/components/RadioBlockItem/RadioBlockItem";

const rolesData: IRadioBlockItem[] = [
  {
    id: 6,
    icon: "BsStar",
    titleKey: "roles.Observer",
    subtitleKey: "roles.ObserverSubtitle",
    color: "#93c5fd",
  },
  {
    id: 5,
    icon: "BsStarHalf",
    titleKey: "roles.Manager",
    subtitleKey: "roles.ManagerSubtitle",
    color: "#60A5FA",
  },
  {
    id: 4,
    icon: "BsStarFill",
    titleKey: "roles.Admin",
    subtitleKey: "roles.AdminSubtitle",
    color: "#1D4ED8",
  },
];

export default rolesData;
